module.exports = __webpack_public_path__ + "img/63_7.939dc5bd.png";